import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftArrow",
  "use": "icon-leftArrow-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 6 11\" id=\"icon-leftArrow\"><g><path d=\"M1.55185,5.5003L5.81169,1.12684C6.06277,0.868632,6.06277,0.450737,5.81169,0.19335C5.56063,-0.06445,5.15329,-0.06445,4.90223,0.19335L0.188015,5.03365C-0.0626716,5.29145,-0.0626716,5.70956,0.188015,5.96655L4.90223,10.8067C5.02815,10.9356,5.19273,11,5.35734,11C5.52196,11,5.68654,10.9355,5.81169,10.8062C6.06277,10.5484,6.06277,10.1311,5.81169,9.87335L1.55185,5.5003Z\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leftArrow.svg
// module id = 9BU7
// module chunks = 103